import { createAsyncThunk } from '@reduxjs/toolkit';

import {
	getRolesList as getRolesListApi,
	getRole as getRoleApi,
	addRole as addRoleApi,
	updateRole as updateRoleApi,
	deleteRole as deleteRoleApi,
	getUserByRoles as getUserByRolesApi,
	getMenuScopesRole as getMenuScopesRoleApi
} from '../../../helpers/auth/backend_helper';
import { toast } from 'react-toastify';

export const getRolesList = createAsyncThunk('role/getRolesList', async () => {
	try {
		const response = getRolesListApi();
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getRole = createAsyncThunk('role/getRole', async id => {
	try {
		const response = getRoleApi(id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const addNewRole = createAsyncThunk('role/addRole', async role => {
	try {
		const response = addRoleApi(role);
		toast.success('Perfil agregado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al agregar el perfil.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const updateRole = createAsyncThunk('role/updateRole', async role => {
	try {
		const response = updateRoleApi(role);
		toast.success('Perfil actualizado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al actualizar el perfil.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const deleteRole = createAsyncThunk('role/deleteRole', async id => {
	try {
		const response = deleteRoleApi(id);
		toast.success('Perfil eliminado exitosamente.', { autoClose: 3000 });
		return response;
	} catch (error) {
		toast.error('Error al eliminar el perfil.', { autoClose: 3000 });
		throw new Error(error);
	}
});

export const getUserByRoles = createAsyncThunk('role/getUserByRoles', async (roles) => {
	try {
		const response = getUserByRolesApi(roles);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});

export const getMenuScopesRole = createAsyncThunk('role/getMenuScopesRole', async id => {
	try {
		const response = getMenuScopesRoleApi(id);
		return response;
	} catch (error) {
		throw new Error(error);
	}
});
